import { Api } from "./Api";
import { JournalEntry } from "../models/JournalEntry";
import _ from "lodash";
import axios from "axios";

export class JournalApi extends Api {
    constructor() {
        super("journal");
    }

    getAll(params?: Object): Promise<Api.CallResponse> {
        return this.getResources(params).then(function (response) {
            let res: Array<JournalEntry> = [];
            if (response.data && response.data.data) {
                res = _.map(response.data.data, function (e) {
                    return new JournalEntry(e);
                });
            }
            return {
                data: res,
                metadata: response.data.metadata,
                paginator: response.data.paginator,
            };
        });
    }

    get(id: Number, params?: Object): Promise<JournalEntry> {
        return this.getResource(id, params).then(function (response) {
            return new JournalEntry(response.data.data);
        });
    }

    save(entry: JournalEntry, params?: Object): Promise<JournalEntry> {
        return super
            .saveResource(entry.serialize(), params)
            .then(function (response) {
                return new JournalEntry(response.data.data);
            });
    }

    delete(id: Number, raison: string): Promise<JournalEntry> {
        return super.deleteResource(id, raison).then(function (response) {
            return new JournalEntry(response.data.data);
        });
    }

    mergeFolders(folderAId: Number, folderBId: Number): Promise<JournalEntry> {
        return axios
            .post(this.apiUrl + "merge/" + folderAId + "/" + folderBId)
            .then(function (response) {
                return new JournalEntry(response.data.data);
            });
    }
}
